// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__35gQn","wrapper-nopadding":"wrapper-nopadding__RiaBM","loading":"loading__2MW-B","error":"error__3SWgf","table-loading":"table-loading__2sGpX","empty-val":"empty-val__lDNHk","panelheader-tools":"panelheader-tools__NMcmT","propsPanels":"propsPanels__19EYH","new":"new__3Xtma","marginLm":"marginLm__3oWnK","marginRm":"marginRm__2Ri-2","fullWidth":"fullWidth__1G-SJ","fullHeight":"fullHeight__3vTZ1","noData":"noData__3hL1S","container":"container__24Oac"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/coms/BroadcastView/styles.scss
// module id = 2184
// module chunks = 1